export default __webpack_public_path__ + "1846fd2391d44d728ffe22dd683aea40.png";